const staticConstants = {
  PANDO_NETWORK: 'Pando Network Transporter',
  GENERATE_VOUCHER_PROMPT: 'Group selected invoices  into a Voucher?',
  INVOICE_VERIFY_PROMPT: 'Verify selected invoices?',
  INVOICE_APPROVE_PROMPT: 'Selected Invoices have been Approved!',
  INVOICE_VERIFY_PROMPT_REJECT: 'Hold selected invoice?',
  INVOICE_APPROVE_PROMPT_REJECT: 'Selected Invoices will be rejected!',
  VOUCHER_VERIFY_PROMPT: 'Verify selected Vouchers?',
  VOUCHER_APPROVE_PROMPT: 'Selected Vouchers Approved!',
  VOUCHER_VERIFY_PROMPT_REJECT: 'Hold selected Voucher?',
  VOUCHER_APPROVE_PROMPT_REJECT: 'Reject selected Voucher?',
  INVOICE_REAPPROVE_PROMPT: 'Approve Invoice on hold?',
  OPTIMA_INITAL_TEXT: 'Add Materials to optimize Indents',
  OPTIMA_LOADING_TEXT: 'Validating your input..',
  OPTIMA_INDENT_DELETE_PROMPT: 'Discard Selected Indent?',
  OPTIMA_INDENT_DELETE_ALL_PROMPT: 'All Indent Discard?',
  OPTIMA_INDENT_SELECTION: 'Upto five indents can be edited together at a time!',
  OPTIMA_INDENT_CREATE_PROMPT: 'Create these #firstArgument# Indents?',
  OPTIMA_INDENT_UNLOADING_THROUGHPUT_WARNING: ' Please verify the indent as Unloading throughput  on  #firstArgument# would be breached  based on  #secondArgument#  in the gate-#fourthArgument#',
  OPTIMA_INDENT_LOADING_THROUGHPUT_WARNING: ' Please verify the indent as loading throughput  on  #firstArgument# would be breached  based on  #secondArgument#  in the gate-#fourthArgument#',
  OPTIMA_DISCARD_SAVE_PROMPT: 'Discard all changes?',
  OPTIMA_MATERIAL_DELETE_PROMPT: 'Delete selected materials?',
  OPTIMA_CONSIGNEE_MOVE_VALIDATE: 'Validating move to ',
  OPTIMA_CONSIGNEE_MOVE_ROUTE: 'No common contracts!',
  OPTIMA_CONSIGNEE_DELETE_PROMPT: 'Delete consignee?',
  GATE_DELETE_PROMPT: 'Are you sure want to delete this #firstArgument# ?',
  CONSIGNEES_DELETE_PROMPT: 'Are you sure want to delete consignees ?',
  INDENT_NO_CONTRACT: 'Contracts not found based on consignments!',
  INDENT_CONTRACT_COUNT: 'Contracts Available: #firstArgument# PTL and #secondArgument# FTL',
  DISCARD_CHANGES: 'Are you sure you want to discard all of your changes?',
  INDENT_HAS_NO_CONSIGNEES: 'Consignees has not been added yet',
  INDENT_HAS_NO_TRANSPORTER: 'Select the Transporter',
  INDENT_HAS_NO_VEHICLE: 'Select the Vehicle Type',
  INDENT_HAS_NO_EXPECTED_DATE: 'Select the Expected Delivery Date',
  GATE_HAS_NO_CONSIGNEE: '#firstArgument# has no consignees',
  BULK_IN_PROGRESS: 'Uploading and Validating data!',
  FREIGHT_RATE_CHANGES: 'Enter the freight amount',
  NO_DEPOT_ACCESS: "Doesn't have access for Depots!",
  GRN_SUBMIT_PROMPT: 'Are you sure want to approve all #firstArgument# consignees?',
  EPOD_VALUE_CHANGED: 'EPOD values have not been saved. Changes will be lost if not saved!',
  EMAIL_SENT_INFO: 'We have taken your request. Please check your email for details',
  SLAB_CONFIGURATION_CHANGED: 'New slab has not been saved. Changes will be lost if not saved!',
  COURIER_WARNING: 'The Carrier Partner is taking a bit longer to respond.The Consignment number will be updated once it is confirmed by - #firstArgument#',
  POD_APPROVAL_PROMPT: 'Are you sure want to approve the POD for this destination #firstArgument# ?',
};

export default staticConstants;
